import { render, staticRenderFns } from "./priceIncreaseSet.vue?vue&type=template&id=4b48b68a&scoped=true"
import script from "./priceIncreaseSet.vue?vue&type=script&lang=js"
export * from "./priceIncreaseSet.vue?vue&type=script&lang=js"
import style0 from "./priceIncreaseSet.vue?vue&type=style&index=0&id=4b48b68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48b68a",
  null
  
)

export default component.exports